export const CANONICAL_META_SELECTORS = [
  'og:url',
];
